import { useAuthStore } from '@/modules/auth/store/auth';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { isClient } = useAuthStore();

  if (isClient) {
    return navigateTo('/');
  }
});
